import React from 'react'
import { showReportDialog } from '@sentry/react'
import { get, isObjectLike } from 'lodash'

import { DataDebug } from 'components/Util/DataDebug'
import Button from 'components/UI/Button'

const DevError = ({ currentUser, originalError, appError, sentryEventId }) => {
    let renderOriginalError

    if (originalError) {
        if (React.isValidElement(originalError)) {
            renderOriginalError = originalError
        } else if (originalError && originalError.stack && originalError.message) {
            renderOriginalError = (
                <>
                    {originalError.message}
                    {originalError.stack}
                </>
            )
        } else if (isObjectLike(originalError)) {
            renderOriginalError = JSON.stringify(originalError, null, 2)
        } else if (originalError.toString) {
            renderOriginalError = originalError.toString()
        } else {
            renderOriginalError = originalError.message || 'Invalid error data'
        }
    }

    return (
        <div className="dev-error">
            <span className="dev-error__message">{appError.message}</span>
            <br />
            [<span className="dev-error__type">{appError.type}</span>:&nbsp;<span className="dev-error__code">{appError.code}</span>]
            <br />
            <br />
            {renderOriginalError && (
                <DataDebug title="Origin">
                    {originalError.message}
                    {originalError.stack}
                </DataDebug>
            )}
            {sentryEventId && (
                <>
                    <br />
                    <Button
                        className="button button--plain"
                        onClick={() => showReportDialog({
                            eventId: sentryEventId,
                            user: {
                                email: get(currentUser, 'me.email', ''),
                                name: get(currentUser, 'me.fullName', ''),
                            },
                        })}
                        trackName="sendSentryReportAdmin"
                    >
                        Lähetä raportti (admin)
                    </Button>
                </>
            )}
        </div>
    )
}

export default DevError
